import React, { useState ,useEffect} from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Container,
  Row,
  Col,
  Form,
  Card,
  Modal,
  Table,
} from "react-bootstrap";
import {
  BiRightArrowAlt,
  BiLeftArrowAlt,
  IoIosArrowBack,
  BiCopy,
  MdContentCopy,
  BsFillMenuButtonWideFill,
  BiListUl,
} from "react-icons/all";
import { TbTransformFilled } from "react-icons/tb";
import {
  CgMenuGridR,
  HiOutlineDocumentSearch,
  AiOutlineQrcode,
  IoIosArrowForward,
  AiOutlineClose,
} from "react-icons/all";
import usdt from "../../assets/images/deposit/tether.svg";
import btc from "../../assets/images/deposit/bitcoin.png";
import trx from "../../assets/images/deposit/TRX.svg";
import xrp from "../../assets/images/deposit/xrp.svg";
import ltc from "../../assets/images/deposit/litecoin.png";
import video from "../../assets/images/deposit/video.png";
import QrCodes from "../qrCode/qrCode";
import ReactPlayer from "react-player";
import Depos_modal from "./depos_modal";

import "./depos.css";
import Transactionhistory from "./transactionhistory";
import Selectcomponent from "./selectcomponent";
import Selectnetwork from "./selectnetwork";
import Expselects from "./expselects";
import Select_drop from "./select_drop_ui/select_drop";
import Searchbox from "./searchbar";
import PrimeSelect from "./deposit_prime/primeSelect";
import { useDispatch, useSelector } from "react-redux";
import { walletShortFormer } from "../../helperData/helper";
import { toast } from "react-toastify";
import { AXIOS, api_key } from "../../config";
import ReactTable from "../withdraw/reactTable";
import { coinInfo, updateCoinWalletStatus } from '../../store/deposit';
import DepositHistory from "./depositHistory";


const Depos = () => {
  const navigate = useNavigate();
  const [listOfNetworks, setListOfNetworks] = useState([])
  const [options, setOptions] = useState()
  const {value,label} = useSelector((state: any) => state.network.selectedNetwork);

  const handleGoBack = () => {
    navigate(-1);
  };

  const columns = [
    { Header: "Time", accessor: "time" },
    { Header: "Currency", accessor: "currency" },
    { Header: "Amount", accessor: "amount" },
    { Header: "Network", accessor: "network" },
    { Header: "Address", accessor: "address" },
    { Header: "TXID", accessor: "txid" },
    { Header: "Status", accessor: "status" },
    // { Header: "Status", accessor: "status" },
  ];
  const [data, setData] = useState([]);
  const [selectedValues, setSelectedValues] = useState({
    selectedCoin:{
        value: '',
        label: '',
        coinId: '',
        imgUrl: '',
        contentType: ''
    },
    selectedNetwork:{
        value: '',
        label: '',
     
    }
});
  const [selectedOption, setSelectedOption] = useState(null);
  let userid = sessionStorage.getItem("userid");
  const dispatch = useDispatch();

  const { coinWallet, walletAddress, networkId, coinId ,coinOfNetworkId,coinSymbol} = useSelector(
    (state: any) => state.deposit
  );
 
  const handleSelectedChange = (selected) => {
    setSelectedOption(selected);
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const getNetworkslist = async () => {
    try {
        const response = await AXIOS.post('/depositNetworkList', {
            api_key: api_key,

        });

        console.log('network response', response.data.data)

        const options = response.data.data.map((network: any) => ({
            value: network.symbol,
            label: network.name,
            networkId: network._id
        }));


        setListOfNetworks(options);
    }
    catch (error: any) {
        toast.error(error.message)
    }
}
useEffect(() => {
    getNetworkslist();
    (async function () {
        try {
            const response = await AXIOS.post('/getCoinList', {
                api_key: api_key,

            });

            const options = response.data.data.map((coin: any, index: number) => ({
                value: coin.symbol,
                label: coin.name,
                coinId: coin._id,
                imgUrl: coin.image_url.img.data,
                contentType: coin.image_url.img.contentType
            }));
            setOptions(options)

        }
        catch (error: any) {
            toast.error(error.message)
        }
    })();

}, []);

const handleSelectChange = (selectedOption, selectName) => {
  console.log('selectedOptionselectedOption',selectedOption)
  if(selectName=='selectedCoin'){
    const {label,coinId,value}=selectedOption
    dispatch(coinInfo({coinId:coinId,coinName:label,coinSymbol:value}));
  }
 
    setSelectedValues(prevState => ({
        ...prevState,
        [selectName]: selectedOption ? selectedOption : {
            label:'',
            value:''
        },
    }));
};

const getCoinofNetwork=async()=>{
    let response=await AXIOS
       .post('getCoinOfNetwork', {
         api_key: api_key,
         name: selectedValues.selectedCoin.label,
         symbol: selectedValues.selectedCoin.value,
         network:selectedValues.selectedNetwork.label
 
       })
       let coinId= response.data.data._id
    //    dispatch(updateCoinOfNetwrokId(response.data.data._id))
   }
   
   useEffect(() => {
     if (selectedValues.selectedCoin.label !='' && selectedValues.selectedNetwork.label !=='') {
       getCoinofNetwork()
     }
 
   }, [selectedValues]);

  const getAddress = async () => {
    const response = await AXIOS.post("/createWallet", {
      api_key: api_key,
      network_id: networkId,
      coin_id: coinOfNetworkId,
      user_id: userid,
    });
   
    if (response.data.showableMessage == "Wallet Created") {
      dispatch(
        updateCoinWalletStatus({
          status: "Wallet found",
          walletAddress: response.data.data.wallet_address,
          networkId: coinOfNetworkId,
        })
      );
    } else {
      toast.error(response.data.showableMessage);
    }
  };
  {
    console.log("walletAddress", walletAddress);
  }

  const [closeVerify, setCloseVerify] = useState(true);

  const handleCloseVerify = () => {
    setCloseVerify(false);
  };

  return (
    <>
      <div className="deposit mt-5 mb-5" style={{ color: "var(--text-clr)" }}>
        <Container>
          <Row>
            <Col>
              <div className="deposit_head d-flex justify-content-between mb-5">
                <div
                  className="dep_hd_hd d-flex gap-2"
                  onClick={handleGoBack}
                  style={{ cursor: "pointer" }}
                >
                  <i style={{ fontSize: "1.5rem", fontWeight: "bold" }}>
                    <IoIosArrowBack />
                  </i>
                  <h2>Digital Currency Deposit</h2>
                </div>
             
              </div>

              <Container fluid className="mt-5 mb-5"> 
                {closeVerify && (
                  <Row className="mt-3">
                    <Col>
                      <div className="depo_after_verif d-flex justify-content-between">
                     
                        <div className="4_boxes">
                          <div className="d-flex gap-4 wd_bx_4">
                            
                            <div className="wd_fst_box">
                              <div className="cnt_bg">
                                <span>1</span>
                              </div>
                              <div>
                                <h6>Copy deposit address</h6>
                                <p>
                                  Select currency and block network you want to
                                  deposit, and copy the deposit address on this
                                  page.
                                </p>
                              </div>
                            </div>
                            
                            <div className="wd_scnd_box">
                              <div className="cnt_bg">
                                <span>2</span>
                              </div>
                              <div>
                                <h6>Initiate deposit</h6>
                                <p>
                                  Initiate a withdrawal on the other party's
                                  platform.
                                </p>
                              </div>
                            </div>
                            
                            <div className="wd_thrd_box">
                              <div className="cnt_bg">
                                <span>3</span>
                              </div>
                              <div>
                                <h6>Network Confirmation</h6>
                                <p>
                                  Wait for the blockchain network to confirm
                                  your transfer.
                                </p>
                              </div>
                            </div>
                            
                            <div className="wd_frth_box">
                              <div className="cnt_bg">
                                <span>4</span>
                              </div>
                              <div>
                                <h6>Successful deposit</h6>
                                <p>
                                  After blockchain confirmation, SuperEx will
                                  post it for you.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div
                          className="closebtn"
                          onClick={handleCloseVerify}
                          style={{ cursor: "pointer" }}
                        >
                          <i>
                            <AiOutlineClose />
                          </i>
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
              </Container>

            

              <Container>
                <Row>
                  <Col md={8}>
                    <div className="inputs">
                      <div className="dp_fst d-flex gap-2">
                       
                        <div className="drop w-100 mb-3 text-dark">
                          <h6 style={{color:"var(--text-clr)"}}>Choose Currency</h6>
                          <Select
                                options={options}
                                isSearchable={true}
                                placeholder='select coin'
                                onChange={(option) => handleSelectChange(option, 'selectedCoin')}
                                components={{ Option: CustomOption }}
                            />
                          {/* <Searchbox /> */}
                
                        </div>
                      </div>

                      <div className="dp_scnd d-flex gap-2 mt-3">
                     
                        <div className="drop w-100 text-dark">
                          <Selectnetwork />
                        </div>
                      </div>

                      <div className="dp_thrd d-flex gap-2 mt-3">
                   
                        <div className="dp_inp_hd w-100">
                          {coinWallet && coinWallet == "Wallet not found" && (
                            <>
                              <h6>Deopsit Address</h6>
                              <Card
                                className="dp_thrd_crd mt-3 p-2 text-center"
                                style={{ width: "100%", background: "#6C757D" }}
                              >
                                <Card.Img
                                  variant="top"
                                  src={xrp}
                                  className="mx-auto"
                                  style={{ width: "10%" }}
                                />
                                <Card.Title>
                                  No BNB Beacon Chain (BEP2) deposit address
                                </Card.Title>
                                <Card.Text>
                                  No BNB Beacon Chain (BEP2) deposit address has
                                  been previously created. Please first create a
                                  deposit address.
                                </Card.Text>
                                <div>
                                  <Button
                                    variant="warning"
                                    onClick={() => getAddress()}
                                  >
                                    Get Address
                                  </Button>
                                </div>
                              </Card>
                            </>
                          )}                      
                          {coinWallet && coinWallet == "Wallet found" && (
                            <div className="dp_add">
                              <>
                                <div className="deposit_add_drop d-flex gap-2">
                                  <div className="d-flex gap-2">
                                    <span>
                                      Deposit Address
                                      {walletAddress}
                                    </span>
                                    <i style={{cursor: 'pointer'}}   onClick={() => {
                                        navigator.clipboard.writeText(
                                          walletAddress
                                        );
                                        toast.success("copied");
                                      }} >
                                      <MdContentCopy />
                                    </i>
                                  </div>
                                  <div>
                                    <div className="depo_add_icon" style={{cursor: 'pointer'}}>
                                      <AiOutlineQrcode />
                                      <div className="depo_add_content">
                                        <span>Deposit Address</span>
                                        <div
                                          className="mx-auto p-2"
                                          style={{
                                            background: "white",
                                            width: "fit-content",
                                          }}
                                        >
                                          <QrCodes
                                            sizeOfQR={100}
                                            value={walletAddress}
                                          />
                                        </div>
                                        <span>
                                          This address can only receive funds
                                          {coinSymbol}
                                          <br /> Please confirm again that the
                                          main network you selected is {label}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>                             
                              </>
                              <div>
                                <hr />
                              </div>
                              <div>
                                <div className="d-flex justify-content-between">
                                  <div>
                                    <p>Minimum deposit amount</p>
                                    <p>Expected Arrival</p>
                                    <p>Expected Unlock</p>
                                  </div>
                                  <div className="text-end">
                                    <p>0.0000001 {coinSymbol}</p>
                                    <p>3 Block Confirmation</p>
                                    <p>12 Block Confirmation</p>
                                  </div>
                                </div>
                                <p>*This address can only receive funds {coinSymbol}</p>
                                <p>
                                  *Please confirm again that the main network
                                  you selected is {label}
                                </p>
                             
                              </div>
                            </div>
                          )}                  
                        </div>
                      </div>
                    </div>
                  </Col>           
                </Row>
                <DepositHistory/>
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Depos;

const CustomOption = ({ data, innerProps }) => (
    <div {...innerProps} className='py-2 custom-option '>
        <img src={`data:${data.contentType};base64, ${data.imgUrl}`} className='img-fluid mx-2' width={35} height={35} />

        {data.label}
    </div>
);

